import React from 'react';

export default function Auth({component}) {
  return (
    <div className='flex font-RCB'>
      <div className='relative flex w-full'>
        <img src='./login_image_full.jpg' alt='login' className='absolute h-screen w-full object-cover -z-10' />
        <div className='hidden lg:block relative w-1/2'></div>
        <div className='flex items-center justify-center h-screen w-full lg:w-1/2 px-4 '>
          <div className='auth-form py-8 px-10 rounded-lg lg:min-w-[400px] '>
            {component}
          </div>
        </div>
      </div>
      
    </div>
  );
}
